var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 54,
    viewBox: "0 0 42 54",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1603 -756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "62zea",
    d: "M1604.604 765.497v43.006h30.792v-34.631c.478.077.968.12 1.465.127V810h-33.721v-46H1627c0 .509.038 1.009.112 1.497z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "62zeb",
    d: "M1609.902 774.837h20.28a.74.74 0 0 0 .732-.748.74.74 0 0 0-.733-.749h-20.279a.74.74 0 0 0-.732.749.74.74 0 0 0 .732.748z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "62zec",
    d: "M1609.902 781.458h20.28a.74.74 0 0 0 .732-.75.74.74 0 0 0-.733-.748h-20.279a.74.74 0 0 0-.732.749.74.74 0 0 0 .732.749z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "62zed",
    d: "M1609.902 788.088h20.28a.74.74 0 0 0 .732-.75.74.74 0 0 0-.733-.748h-20.279a.74.74 0 0 0-.732.749.74.74 0 0 0 .732.749z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "62zee",
    d: "M1609.902 794.708h20.28a.74.74 0 0 0 .732-.75.74.74 0 0 0-.733-.748h-20.279a.74.74 0 0 0-.732.749.74.74 0 0 0 .732.749z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "62zef",
    d: "M1609.902 801.337h20.28a.74.74 0 0 0 .732-.748.74.74 0 0 0-.733-.749h-20.279a.74.74 0 0 0-.732.749.74.74 0 0 0 .732.748z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1603 -756)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00b195",
    d: "M1641.345 761.87l-5.238 5.561-.675.715-3.432-3.436 1.349-1.35 2.044 2.046 4.563-4.847.655-.696 1.389 1.312zM1637 772a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.4dc380a4.svg";
export { ForwardRef as ReactComponent };